<ng-template linkTemplate let-dataItem="dataItem">
    <div class="container">
        <wbo-edit-link [dataItem]="dataItem" [field]="field" [componentPath]="componentPath"
                       [editMode]="editMode" (onSave)="dataItemSaved(dataItem, $event)"
                       [editComponent]="(dataItem | property: componentPath).sellableType == 'ProductLineData' ? ProductLineEditPageComponent : CompositeProductEditPageComponent"></wbo-edit-link>
        <fui-tags class="discontinued utility color-dusty-gray">
            <fui-tag *ngIf="(dataItem | property: componentPath).discontinued || (dataItem | property: componentPath).unavailable"
                     [title]="(dataItem | property: componentPath).discontinued ? discontinuedLabel : unavailableLabel">
                <fui-icon [height]="14" [icon]="'ban'" [width]="14"></fui-icon>
            </fui-tag>
        </fui-tags>
    </div>
</ng-template>
